module.exports = __webpack_public_path__ + "img/network-reaction.45829b6.jpeg";